export const reservasPanels = {
  // OtaMessages.vue
  ota: {
    appTitle: "Enable OTA messages",
    installIntro:
      "To reply to your Booking.com / Airbnb guests from WA Checkin, you need to install the",
    installIntroTail: "app on the accommodation.",
    installBtn: "Install OTA messaging",
    installing: "Installing the messaging module…",
    retryLink: "I've already installed the app, check again",
    loading: "Loading OTA messages…",
    empty: "No OTA messages for this booking.",
    modeAi: "AI",
    modeManual: "Manual",
    predefinedHeader: "Quick replies",
    predefinedEmpty: "No matching replies.",
    inputPlaceholder: "Type a message or use / for quick replies...",
    attachTitle: "Attach image",
    senderGuest: "Guest",
    senderProperty: "Accommodation",
    senderSystem: "System",
    senderUnknown: "Unknown",
    fileFallback: "file",
    toastTitle: "OTA messages",
    errorTitle: "Error",
    loadError: "Could not load the OTA messages.",
    modeErrorDetail: "Could not identify the OTA chat. Try reloading the page.",
    modeManualOnTitle: "Manual mode enabled",
    modeAiOnTitle: "AI agent enabled",
    modeManualOnDetail: "You'll reply to messages manually",
    modeAiOnDetail: "The bot will reply automatically",
    modeChangeError: "Could not change the OTA chat mode",
    sendError: "Could not send the OTA message.",
    onlyImagesTitle: "Images only",
    onlyImagesDetail: "OTAs only allow sending images.",
    imageTooBigTitle: "Image too large",
    imageTooBigDetail: "The image can't be larger than 5 MB.",
    installNoProperty: "No property connected to Channex was found.",
    installOk: "Application installed successfully.",
    installError: "Could not install the application.",
  },

  // ReservationNotes.vue
  notes: {
    composerPlaceholder: "Write an internal note…",
    saveHint: "⌘ / Ctrl + Enter to save",
    saving: "Saving…",
    addNote: "Add note",
    loading: "Loading notes…",
    emptyTitle: "No notes yet",
    emptyText: "Add the first internal note from the box above.",
    cancel: "Cancel",
    save: "Save",
    team: "Team",
    confirmDelete: "Delete?",
    yes: "Yes",
    no: "No",
    editTitle: "Edit",
    deleteTitle: "Delete",
    loadError: "Could not load the notes",
    added: "Note added",
    saveError: "Could not save the note",
    updated: "Note updated",
    updateError: "Could not update the note",
    deleted: "Note deleted",
    deleteError: "Could not delete the note",
  },

  // ReservationPaymentsPanel.vue
  payments: {
    pendingLabel: "Pending",
    paidLabel: "Collected",
    totalLabel: "Total",
    loading: "Loading payments…",
    empty: "No payment has been recorded yet.",
    addPayment: "Add payment…",
    fullyPaid: "Booking fully paid",
    recalcTitle: "Recalculate",
    sendWhatsappTitle: "Send via WhatsApp",
    copyLinkTitle: "Copy link",
    editAction: "Edit",
    deleteAction: "Delete",
    modalEditTitle: "Edit payment",
    modalAddTitle: "Add payment",
    amountLabel: "Amount to charge",
    fillRemaining: "Charge the remaining ({amount})",
    methodLabel: "Payment method",
    sendWhatsappCheck: "Send the link to the guest via WhatsApp",
    noteLabel: "Note (optional)",
    notePlaceholder: "E.g. deposit, pay on arrival…",
    cancel: "Cancel",
    save: "Save",
    generateLink: "Generate link",
    registerPayment: "Record payment",
    deleteConfirmTitle: "Delete this payment?",
    deleteText1: "This will delete the payment of",
    deleteLinkVoided: "The payment link will be voided.",
    deleteIrreversible: "This action can't be undone.",
    deleteBtn: "Delete payment",
    sendConfirmTitle: "Send the payment link?",
    sendText1: "The guest will be sent the link to pay via WhatsApp for",
    sendBtn: "Send link",
    methodCash: "Cash",
    methodCard: "Card / physical terminal",
    methodTransfer: "Bank transfer",
    methodOta: "Paid via OTA",
    statusPaid: "Collected",
    statusPending: "Pending",
    statusFailed: "Failed",
    statusCancelled: "Cancelled",
    loadError: "Could not load the payments.",
    amountRequired: "Enter an amount.",
    saveError: "Could not save the payment.",
    deleteError: "Could not delete it.",
    sendLinkError: "Could not send the link.",
    recalcError: "Could not recalculate.",
  },

  // RoomAssignmentPanel.vue
  roomAssign: {
    title: "Assign room",
    subWithUnitPre: "This booking for",
    subWithUnitPost: "doesn't have a physical room assigned yet.",
    subNoUnit: "This booking doesn't have a physical room assigned yet.",
    loading: "Checking availability…",
    freePre: "Rooms available for",
    freePost: "Pick one and assign it directly:",
    freeBadge: "Free",
    assigning: "Assigning…",
    occupiedNote:
      "{count} room occupied on these dates | {count} rooms occupied on these dates",
    noneFreeTitle: "There are no free rooms for these dates.",
    noFreePre: "All the rooms in",
    thisType: "this type",
    noFreeMid:
      "are occupied or blocked on {date}. To assign this booking,",
    reorganizeBold: "rearrange the bookings",
    noFreeMid2: "for this room type from the calendar (the",
    organizeBtn: "Organize",
    noFreeTail: " button) to free one up.",
    tagMaintenance: "Maintenance",
    tagBlocked: "Blocked",
    theseDates: "these dates",
    occupied: "Occupied",
    assignedOk: "Room {label} assigned successfully.",
    assignError: "Could not assign the room.",
    notifyError: "Error",
    notifyDone: "Done",
  },

  // GroupRoomsPanel.vue
  groupRooms: {
    heading: "Rooms in this booking",
    typesCount: "{count} type | {count} types",
    roomsCount: "{count} room | {count} rooms",
    guestsCount: "{count} guest | {count} guests",
    totalLabel: "Total",
    viewingBadge: "Viewing",
    noRoomAssigned: "No room assigned",
    removeOneRoom: "Remove one room",
    addOneRoom: "Add one room",
    confirmRemove: "Remove?",
    yes: "Yes",
    no: "No",
    cannotRemoveOnly: "You can't remove the only room",
    removeRoomFromBooking: "Remove this room from the booking",
    updating: "Updating…",
    theChannel: "the channel",
    otaManaged:
      "This room is managed by {channel}: quantity and price are changed there.",
    notifyError: "Error",
    notifyDone: "Done",
    qtyUpdated: "Quantity updated",
    roomRemoved: "Room removed from the booking",
    updateError: "Could not update the booking. Please try again.",
  },
};
